import { DeliveryProvider } from '../../../../services/exports/Constants';

export default {
  [DeliveryProvider.Standalone]: 'Flotă proprie de șoferi',
  [DeliveryProvider.UberDrive]: 'Uber drive',
  [DeliveryProvider.WoltDrive]: 'Wolt drive',
};
